import React, {useState} from "react";
import {Col, Row} from "reactstrap";
import {UploadStates, WarrantyAndReturnMessageSenderTypes} from "../../../../../../core/constants/enums";
import IconButton from "../../../../base/button/icon_button";
import {CircularProgress, Fade, SvgIcon} from "@mui/material";
import {ReactComponent as Remove} from "../../../../../../assets/images/remove.svg";
import {Autorenew, CheckCircleOutline, ErrorOutline, Share} from "@mui/icons-material";
import ElementIds from "../../../../../../core/models/element-ids";

const TextBubbles = ({data, removeMessage, sendAgain, className = '', forward, canForward, ...props}) => {
    const [removing, setRemoving] = useState(false);
    const [sending, setSending] = useState(false);
    const [forwarding, setForwarding] = useState(false);
    const [hover, setHover] = useState(false);

    const isFromUserChat = !!props['old-structure'];
    const forwardedData = data.forwardedMsgInfo;
    const shouldUseOldStructure = isFromUserChat || !!forwardedData;

    let isFromCurrent = data.senderTypeID === WarrantyAndReturnMessageSenderTypes.operator;
    let isFromSystem = data.senderTypeID === WarrantyAndReturnMessageSenderTypes.system;
    if (!isFromUserChat) {
        isFromCurrent = !!data.operator;
    }

    return (
        <Row
            id={shouldUseOldStructure
                ? `${forwardedData?.submitDateTime?.toString() ?? data.submitDateTime?.toString()}-${forwardedData?.typeID ?? data.typeID}`
                : `${data.submittedDateTime.toString()}-${data.msgType.id}`}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            className={`w-100 no-gutters my-3 ${isFromCurrent ? 'justify-content-end' : isFromSystem ? "justify-content-center" : 'justify-content-start'} ${className}`}
        >
            {
                isFromCurrent
                && isFromUserChat
                && canForward
                && (
                    <Fade in={hover} unmountOnExit mountOnEnter>
                        <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                            <IconButton
                                className={'mr-1'}
                                disabled={removing || sending || forwarding}

                                onPressed={() => forward(data, setForwarding)}
                                color={'paper.secondary'}
                            >
                                <Share className={'icon normal'}/>
                            </IconButton>
                        </div>

                    </Fade>
                )
            }
            {
                isFromCurrent
                && !isFromSystem
                && data.uploadState?.state === UploadStates.done
                && (
                    <Fade in={hover} unmountOnExit mountOnEnter>
                        <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                            <IconButton
                                className={'mr-2'}
                                disabled={removing || sending}

                                onPressed={() => removeMessage(data, setRemoving)}
                                color={'paper.error'}
                            >
                                <SvgIcon className={'icon normal'} component={Remove}/>
                            </IconButton>
                        </div>

                    </Fade>
                )
            }
            <div className={`${
                isFromSystem
                    ? 'system-message-container'
                    : ''
            }`}>
                <div
                    className={`rounded-xxl p-3 
                        ${
                        isFromCurrent
                            ? 'background-secondary-color-1'
                            : 'background-tertiary'} 
                        ${
                        data.uploadState?.state === UploadStates.pending
                            ? 'cursor-progress-hover'
                            : data.uploadState?.state === UploadStates.error
                                ? 'cursor-pointer-hover'
                                : 'cursor-default-hover'
                    }
                        ${
                        isFromSystem
                            ? 'system-message'
                            : ''
                    }
                        `}
                    style={{
                        maxWidth: (document.getElementById(ElementIds.partSupportChat.body)?.clientWidth ?? 100) / 2,
                    }}>
                    <p className={`text-sm text-left text-wrap ${isFromCurrent ? 'white' : 'text-color-1'}`}>
                        {forwardedData?.data ?? data.data ?? 'message not available'}
                    </p>
                </div>
                {
                    !!forwardedData &&
                    <Col
                        xs={12}
                        className={`d-flex p-0 ${isFromCurrent ? 'justify-content-start' : 'justify-content-end'}`}
                    >
                        <p className={'text-xs text-color-3 ml-2 mt-1'}>Forwarded</p>
                    </Col>
                }
            </div>

            {
                isFromCurrent
                && !isFromSystem
                && (
                    <div className={'d-flex flex-column align-items-end justify-content-end ml-1'}>
                        <Fade in={data.uploadState?.state === UploadStates.error} unmountOnExit mountOnEnter>
                            <ErrorOutline className={'icon red small'}/>
                        </Fade>
                        <Fade in={data.uploadState?.state === UploadStates.done} unmountOnExit mountOnEnter>
                            <CheckCircleOutline className={'icon stroke-grey-1 small'}/>
                        </Fade>
                        <Fade in={data.uploadState?.state === UploadStates.pending} unmountOnExit mountOnEnter>
                            <CircularProgress color={'secondary'} size={15}/>
                        </Fade>
                    </div>
                )
            }
            {
                !isFromCurrent
                && !isFromSystem
                && isFromUserChat
                && canForward
                && data.uploadState?.state === UploadStates.done
                && (
                    <Fade in={hover} unmountOnExit mountOnEnter>
                        <div className={'div justify-content-end align-items-center row no-gutters flex-grow-0'}>
                            <IconButton
                                className={'ml-1'}
                                disabled={removing || sending || forwarding}

                                onPressed={() => forward(data, setForwarding)}
                                color={'paper.secondary'}
                            >
                                <Share className={'icon normal'}/>
                            </IconButton>
                        </div>
                    </Fade>
                )
            }
            {
                !isFromCurrent
                && !isFromSystem
                && data.uploadState?.state === UploadStates.done
                    ? (
                        <Fade in={hover} unmountOnExit mountOnEnter>
                            <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                <IconButton
                                    className={'ml-2'}
                                    disabled={removing || sending}

                                    onPressed={() => removeMessage(data, setRemoving)}
                                    color={'paper.error'}
                                >
                                    <SvgIcon className={'icon normal'} component={Remove}/>
                                </IconButton>
                            </div>

                        </Fade>
                    )
                    : !isFromCurrent
                    && !isFromSystem
                    && data.uploadState?.state === UploadStates.error
                    && (
                        <Fade in={data.uploadState?.state === UploadStates.error && hover} unmountOnExit
                              mountOnEnter>
                            <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                <IconButton
                                    className={'ml-2'}
                                    disabled={sending || removing}

                                    onPressed={() => sendAgain(data, setSending)}
                                    color={'paper.secondary'}
                                >
                                    <Autorenew className={'icon normal'}/>
                                </IconButton>
                            </div>
                        </Fade>
                    )
            }
        </Row>
    );
}

export default TextBubbles;
